"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCTION_ROUTES = exports.RedirectHost = void 0;
var RedirectHost;
(function (RedirectHost) {
    RedirectHost["BACKEND_API_DOMAIN"] = "BACKEND_API_DOMAIN";
})(RedirectHost = exports.RedirectHost || (exports.RedirectHost = {}));
exports.PRODUCTION_ROUTES = [
    {
        pattern: '^/((?<locale>en|en-GB|en-AU|en-NZ|en-IE|es|es-ES|de|de-DE|ja|ja-JP|jp|ko)/?)?$',
        repo: 'buyflow-client',
        context: {
            route_id: '_direct',
            context_type: 'landing',
        },
        redirectOnMissingTrailingSlash: true,
        indexable: true,
    },
    {
        pattern: '/(ja|ja-JP|jp)/.+',
        repo: 'buyflow-client',
        redirect: {
            pathname: '/#',
        },
        indexable: false,
    },
    {
        pattern: '^(/(?<locale>en|en-GB|en-AU|en-NZ|en-IE|es|es-ES|de|de-DE|ko))?/programs/health-weight/(?<route_id>[A-z0-9_-]+)/?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'landing',
        },
        indexable: true,
    },
    {
        pattern: '^/programs/healthy-mind/(?<route_id>[A-z0-9_-]+)/?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'landing',
        },
        indexable: true,
    },
    {
        pattern: '^/programs/healthy-mind/?$',
        repo: 'buyflow-client',
        context: {
            route_id: 'hm-direct',
            context_type: 'landing',
        },
        redirectOnMissingTrailingSlash: true,
        indexable: true,
    },
    {
        pattern: '^/programs/mood/(?<route_id>[A-z0-9_-]+)/?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'landing',
        },
        indexable: true,
    },
    {
        pattern: '^/programs/mood/?$',
        repo: 'buyflow-client',
        context: {
            route_id: 'hm-direct',
            context_type: 'landing',
        },
        redirectOnMissingTrailingSlash: true,
        indexable: true,
    },
    {
        pattern: '^/(?<locale>es|es-ES|de|de-DE)/healthy-weight-program/?$',
        repo: 'buyflow-client',
        context: {
            route_id: '_baseline',
            context_type: 'landing',
        },
        indexable: true,
    },
    {
        pattern: '^/purchase(/(?<locale>en|es|de))?/option_[A-Za-z0-9_]+/?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-checkout',
        },
        indexable: false,
    },
    {
        pattern: '^/purchase(/(?<locale>ko|))?/option_[a-z0-9_]+/?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment',
        },
        indexable: false,
    },
    {
        pattern: '^/purchase-hm/option_[A-Za-z0-9_]+/?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-checkout',
            fallback_route_id: 'hm-direct',
        },
        indexable: false,
    },
    {
        pattern: '^/(?<locale>ko)/.*$',
        repo: 'buyflow-client',
        context: {
            context_type: 'landing',
        },
        indexable: true,
    },
    {
        pattern: '^/purchase/(?<locale>ko)/.*$',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment',
        },
        indexable: false,
    },
    {
        pattern: '^/share(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'share',
        },
        indexable: false,
    },
    {
        pattern: '^/noom-premium(/.*)?$',
        repo: 'buyflow-client',
        context: {
            route_id: 'exsf01',
            context_type: 'noom-premium',
        },
        indexable: false,
    },
    {
        pattern: '^/add-ons/cancel/hm(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'addons-cancel',
            fallback_route_id: 'hm-direct',
        },
        indexable: false,
    },
    {
        pattern: '^/add-ons/hm(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'addons',
            fallback_route_id: 'hm-direct',
        },
        indexable: false,
    },
    {
        pattern: '^/add-ons/cancel(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'addons-cancel',
        },
        indexable: false,
    },
    {
        pattern: '^/add-ons(/.*)?$',
        repo: 'buyflow-client',
        context: {
            route_id: 'exsf01',
            context_type: 'addons',
        },
        indexable: false,
    },
    {
        pattern: '^/offers/noom-med(/.*)$',
        repo: 'buyflow-client',
        context: {
            context_type: 'noom-med-offer',
        },
        indexable: false,
    },
    {
        pattern: '^/offers(/.*)?$',
        repo: 'buyflow-client',
        context: {
            route_id: 'exsf01',
            context_type: 'offers',
        },
        indexable: false,
    },
    {
        pattern: '^/in-app-offers(/.*)?$',
        repo: 'buyflow-client',
        context: {
            route_id: 'app-upsell',
            context_type: 'in-app-offers',
        },
        indexable: false,
    },
    {
        pattern: '^/fast-forward-trial(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'fast-forward',
        },
        indexable: false,
    },
    {
        pattern: '^/in-app-fast-forward-trial(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'in-app-fast-forward',
        },
        indexable: false,
    },
    {
        pattern: '^/supporter-plan(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'supporter-plan',
        },
        indexable: false,
    },
    {
        pattern: '^/noom-together(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'noom-together',
        },
        indexable: false,
    },
    {
        pattern: '^/family-plan-survey(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'family-plan-survey',
        },
        indexable: false,
    },
    {
        pattern: '^/noom-summit(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'noom-summit',
        },
        indexable: false,
    },
    {
        pattern: '^/(r|referral)(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'landing',
            route_id: 'referrals',
        },
        indexable: false, // contains referral, don't index
    },
    {
        pattern: '^/s/(?<route_id>[A-z0-9_-]+)$',
        repo: 'buyflow-client',
        context: {
            context_type: 'landing',
            route_id_prefix: 'social-',
        },
        indexable: false,
    },
    {
        pattern: '^/enrollment(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'enrollment',
        },
        indexable: false,
    },
    {
        pattern: '^/enrollment-hm(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'enrollment',
        },
        indexable: false,
    },
    {
        pattern: '^/cancel/hm(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'hm-counter-offer',
        },
        indexable: false,
    },
    {
        pattern: '^/(subscription|ps)/hm-cancel-subscription(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'hm-cancel-subscription',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/(meal-delivery|snack-delivery|snack-customize)(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'meal-delivery',
        },
        indexable: false,
    },
    {
        pattern: '^/(subscription|ps)/hm-cancel-trial(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'hm-cancel-trial',
        },
        indexable: false,
    },
    {
        pattern: '^/(subscription|ps)/cancel-subscription(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'cancel-subscription',
        },
        indexable: false,
    },
    {
        pattern: '^/(subscription|ps)/med-downgrade(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'med-downgrade',
        },
        indexable: false,
    },
    {
        pattern: '^/(subscription|ps)/cancel-trial(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'cancel-trial',
        },
        indexable: false,
    },
    {
        pattern: '^/cancel(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'counter-offer',
        },
        indexable: false,
    },
    {
        pattern: '^/course(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'course',
        },
        indexable: false,
    },
    // TODO(claire): Remove once client is only using /do-not-share.
    {
        pattern: '^/ccpa-do-not-sell/?$',
        repo: 'buyflow-client',
        redirectOnMissingTrailingSlash: true,
        indexable: true,
    },
    {
        pattern: '^/do-not-share/?$',
        repo: 'buyflow-client',
        redirectOnMissingTrailingSlash: true,
        indexable: true,
    },
    {
        pattern: '^/robots.txt$',
        repo: 'buyflow-client',
        rewrite: { location: '/static/robots.txt' },
        indexable: false,
    },
    {
        pattern: '^/googlebfd1c0f0b3690904.html$',
        repo: 'buyflow-client',
        redirect: {
            pathname: '/static/googlebfd1c0f0b3690904.html',
        },
        indexable: false,
    },
    {
        pattern: '^/favicon.ico$',
        repo: 'buyflow-client',
        redirect: {
            pathname: '/static/favicon.ico',
        },
        indexable: false,
    },
    {
        pattern: '^/noom_logo.png$',
        repo: 'buyflow-client',
        redirect: {
            pathname: '/static/noom_logo.png',
        },
        indexable: false,
    },
    {
        pattern: '^/static/.*$',
        repo: 'buyflow-client',
        indexable: false,
    },
    {
        pattern: '^/pixel/.*$',
        redirect: {
            hostname: RedirectHost.BACKEND_API_DOMAIN,
        },
        indexable: false,
    },
    {
        pattern: '^/internal/app/?$',
        redirect: {
            pathname: '/internal/app/',
            hostname: RedirectHost.BACKEND_API_DOMAIN,
        },
        indexable: false,
    },
    {
        pattern: '^(/.well-known)?/apple-app-site-association$',
        repo: 'buyflow-client',
        redirect: {
            pathname: '/static/empty.html',
        },
        indexable: false,
    },
    {
        pattern: '^/.well-known/apple-developer-merchantid-domain-association$',
        repo: 'buyflow-client',
        rewrite: {
            location: '/static/.well-known/apple-developer-merchantid-domain-association',
        },
        indexable: false,
    },
    {
        pattern: '^/BingSiteAuth.xml$',
        repo: 'buyflow-client',
        rewrite: { location: '/static/BingSiteAuth.xml' },
        indexable: false,
    },
    {
        pattern: '^/ahrefs_d36b84f106714349bb35fe332d1c597e03915d907261ec3f2d62b33e03fb1481$',
        repo: 'buyflow-client',
        rewrite: {
            location: '/static/ahrefs_d36b84f106714349bb35fe332d1c597e03915d907261ec3f2d62b33e03fb1481',
        },
        indexable: false,
    },
    {
        pattern: '^/google6dbbd8f1d79c0807.html$',
        repo: 'buyflow-client',
        rewrite: { location: '/static/google6dbbd8f1d79c0807.html' },
        indexable: false,
    },
    {
        pattern: '^/withings-scale(/.*)?$',
        repo: 'buyflow-client',
        indexable: false,
    },
    {
        pattern: '^/f/personality-quiz(.*)$',
        repo: 'buyflow-client',
        context: {
            context_type: 'free-products-quiz',
        },
        indexable: false,
    },
    {
        pattern: '^/f/(.*)$',
        repo: 'buyflow-client',
        context: {
            context_type: 'free-products',
        },
        indexable: false,
    },
    {
        pattern: '^/body-scan(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'body-scan-intro',
        },
        indexable: false,
    },
    {
        pattern: '^/lead/survey(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'lead-survey',
        },
        indexable: false,
    },
    {
        pattern: '^/commitment-contracts/(.*)$',
        repo: 'buyflow-client',
        context: {
            context_type: 'commitment-contracts',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/trial-check-in(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'trial-check-in',
        },
        indexable: false,
    },
    {
        pattern: '^/p/(.*)$',
        repo: 'buyflow-client',
        context: {
            context_type: 'generic',
        },
        indexable: false,
    },
    {
        pattern: '^/insurance-reimbursement(/.*)?$',
        repo: 'buyflow-client',
        indexable: false,
    },
    {
        pattern: '^/telehealth/feedback(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'telehealth-feedback',
        },
        indexable: false,
    },
    {
        pattern: '^/telehealth/(schedule|reschedule)/followup(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'telehealth-followup',
        },
        indexable: false,
    },
    {
        pattern: '^/telehealth(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'telehealth',
        },
        indexable: false,
    },
    // LBF routes
    {
        pattern: '^/survey/nw-med-branching/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'main-survey-nw-med-branching',
        },
        indexable: false,
    },
    {
        pattern: '^/survey/hm/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'main-survey',
            fallback_route_id: 'hm-direct',
        },
        indexable: false,
    },
    {
        pattern: '^/survey/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'main-survey',
        },
        indexable: false,
    },
    {
        pattern: '^/referrals/survey/hm/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'referrals-survey',
            fallback_route_id: 'hm-direct',
        },
        indexable: false,
    },
    {
        pattern: '^/payment/survey/referrals/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-survey-referrals',
        },
        indexable: false,
    },
    {
        pattern: '^/payment/survey/supporters/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-survey-supporters',
        },
        indexable: false,
    },
    {
        pattern: '^/payment/survey/employer/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-survey-employer',
        },
        indexable: false,
    },
    {
        pattern: '^/payment/survey/(nm-bundle|aging-and-metabolism|movement|sleep|course-enhancements|hrt)/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-survey-nm-bundle',
        },
        indexable: false,
    },
    {
        pattern: '^/payment/results/hm/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-results',
            fallback_route_id: 'hm-direct',
        },
        indexable: false,
    },
    {
        pattern: '^/payment/results/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-results',
        },
        indexable: false,
    },
    {
        pattern: '^/payment/survey/hm/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-survey',
            fallback_route_id: 'hm-direct',
        },
        indexable: false,
    },
    {
        pattern: '^/payment/survey/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-survey',
        },
        indexable: false,
    },
    {
        pattern: '^/payment/hm/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-checkout',
            fallback_route_id: 'hm-direct',
        },
        indexable: false,
    },
    {
        pattern: '^/payment/post-checkout(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-post-checkout',
        },
        indexable: false,
    },
    {
        pattern: '^/payment/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'payment-checkout',
        },
        indexable: false,
    },
    {
        pattern: '^/switch/hm/.*',
        repo: 'buyflow-client',
        context: {
            context_type: 'program-switch',
            fallback_route_id: 'hm-direct',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/in-app-employer-survey(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'in-app-employer-survey',
            route_id: 'app-employer',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/coach-survey(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'coach-survey',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/noom-vibe-survey(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'noom-vibe-survey',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/probiotics-delivery(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'probiotics-delivery',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/zumba-offer(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'zumba-offer',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/noom-vibe-post-purchase(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'noom-vibe-post-purchase',
        },
        indexable: false,
    },
    {
        pattern: '^/noom-vibe/post-purchase(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'noom-vibe-post-purchase',
        },
        indexable: false,
    },
    {
        pattern: '^/ps/coach-referrals(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'coach-referrals',
            route_id: 'coach-referrals',
        },
        indexable: false,
    },
    {
        pattern: '^/coach(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'coach-referrals',
            route_id: 'coach-referrals',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/program-branching(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'program-branching',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/noom-med-switch(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'noom-med-switch',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/hrt-survey(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'hrt-survey',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/hrt-payment-results(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'hrt-payment-results',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/hrt-payment-checkout(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'hrt-payment-checkout',
        },
        indexable: false,
    },
    {
        pattern: '^/lp/clinical(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'landing',
        },
        indexable: false,
    },
    {
        pattern: '^/lp(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'landing',
        },
        indexable: true,
    },
    {
        pattern: '^(/ps)?/app-free-onboarding(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'main-survey',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/app-free-onboarding-future-me(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'app-free-onboarding-future-me',
        },
        indexable: false,
    },
    {
        pattern: '^(/ps)?/app-free-onboarding-complete(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'app-free-onboarding-complete',
        },
        indexable: false,
    },
    {
        pattern: '^/ps/(?<pageset_layer>[A-z0-9_-]+)/?$',
        repo: 'buyflow-client',
        indexable: false,
    },
    {
        pattern: '^(/ps)?/dynamic-survey(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'dynamic-survey',
        },
        indexable: false,
    },
    {
        pattern: '^/nmc/survey/(.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'nmc-survey',
        },
        indexable: false,
    },
    {
        pattern: '^/nmc(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'nmc-landing',
        },
        indexable: true,
    },
    {
        pattern: '^/zumba/?$',
        repo: 'buyflow-client',
        redirect: {
            pathname: '/nmc/zumba',
        },
        indexable: false,
    },
    {
        pattern: '^/premium-plus-in-app-offer(/.*)?$',
        repo: 'buyflow-client',
        context: {
            context_type: 'premium-plus-in-app-offer',
        },
        indexable: false,
    },
];
//# sourceMappingURL=productionRoutes.js.map